const Megaphone = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1748_34679)'>
        <path
          d='M2.31885 9.51785V12.785C2.31885 14.5312 3.73449 15.9469 5.48077 15.9469C7.22704 15.9469 8.64269 14.5312 8.64269 12.785C8.64269 12.2491 8.64269 11.7321 8.64269 11.7321L2.31885 9.51785Z'
          fill='#A5D8FF'
        />
        <path
          d='M14.9727 0.0651706C14.7951 0.0389713 14.614 0.0552535 14.4439 0.11268L1.19832 4.72082C0.866226 4.83691 0.578277 5.05306 0.374089 5.33953C0.169902 5.62601 0.059507 5.96872 0.0581055 6.32051V7.55941L0.058437 7.5788C0.0701694 7.92181 0.185336 8.25325 0.388819 8.52961C0.592303 8.80599 0.874657 9.0144 1.19871 9.12745L14.4386 13.745L14.4439 13.7469C14.614 13.8042 14.7951 13.8205 14.9727 13.7943C15.1502 13.7681 15.319 13.7002 15.4652 13.5961C15.6113 13.492 15.7306 13.3547 15.8135 13.1955C15.8964 13.0363 15.9402 12.8598 15.9415 12.6803V1.18334V1.17914C15.9402 0.999701 15.8964 0.823138 15.8135 0.663948C15.7306 0.504757 15.6113 0.367482 15.4652 0.263393C15.319 0.159305 15.1502 0.0913703 14.9727 0.0651706Z'
          fill='#339AF0'
        />
      </g>
      <defs>
        <clipPath id='clip0_1748_34679'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Megaphone;
